import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/cms/ui/alert-dialog";

interface SubscriptionLimitDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  limitType: 'cannot-publish' | 'publish-limit-reached' | 'no-version-history';
  currentLimit: number;
  userPlan: string;
}

export function SubscriptionLimitDialog({
  open,
  onOpenChange,
  limitType,
  currentLimit,
  userPlan
}: SubscriptionLimitDialogProps) {

  const getDialogContent = () => {
    switch (limitType) {
      case 'cannot-publish':
        return {
          title: "Publishing Not Available",
          message: `Your ${userPlan} plan does not include the ability to publish stories. Upgrade to start sharing your stories with the world.`
        };
      case 'publish-limit-reached':
        return {
          title: "Published Story Limit Reached",
          message: `You've reached your limit of ${currentLimit} published ${currentLimit === 1 ? 'story' : 'stories'}. Upgrade your plan to publish more stories.`
        };
      case 'no-version-history':
        return {
          title: "Version History Not Available",
          message: `Your ${userPlan} plan does not include version history features. Upgrade to access archiving and version management.`
        };
      default:
        return {
          title: "Limit Reached",
          message: "You've reached a limit on your current plan."
        };
    }
  };

  const content = getDialogContent();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="cursor-default select-none">
        <AlertDialogHeader>
          <AlertDialogTitle>{content.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {content.message}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
